var _style, _g, _polygon, _polygon2, _polygon3, _g2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 550 275",
    style: {
      enableBackground: "new 0 0 550 275"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#BC235E;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67,228.7v-71.3h33.4c13.6,0,20.3,5.5,20.3,16.6c0,8.1-4.4,13.9-13.3,17.4c9.4,1.8,14.2,7.2,14.2,16.2 c0,14.1-7.4,21.1-22.3,21.1H67z M98.8,217.2c5.8,0,8.8-3,8.8-9c0-7.4-4.4-11.1-13.1-11.1h-4v-8.5c11-1.8,16.4-6.4,16.4-13.8 c0-4-2.5-6-7.4-6H80.2v48.3H98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,157.4v11.4h-35.7v17.9h34v11.8h-34.1v18.7h36.5v11.5h-49.5v-71.3H181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,228.6v-71.2h32.4c14.6,0,21.8,6.4,21.8,19.1c0,8.6-5.7,15.7-17,21.4l22.6,30.8h-16.6L216,197.6v-6 c12.6-2.2,18.9-7.1,18.9-14.7c0-5.2-3-7.9-8.9-7.9H208v59.6H194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,225.4c-5.7,2.5-12.9,3.8-21.6,3.8c-25.2,0-37.7-12.4-37.7-37.1c0-23.4,12.8-35.1,38.4-35.1 c7.8,0,14.8,1.2,20.9,3.5v12c-6.1-2.7-12.8-4-19.9-4c-17.1,0-25.7,7.9-25.7,23.7c0,17.1,8.1,25.7,24.2,25.7c2.4,0,5.1-0.4,8.2-1.2 v-20.7h13.2V225.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.5888,
    y1: 122.6092,
    x2: 155.8955,
    y2: 65.9173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AB256"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B80C1"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "119.7,134.2 184.2,69.8 151.8,37.4 55,134.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.9236,
    y1: 58.43,
    x2: 292.7511,
    y2: 130.3019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C72884"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E73166"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "264.8,134.2 200.3,69.8 232.7,37.4 329.5,134.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.0546,
    y1: 130.6329,
    x2: 246.6753,
    y2: 56.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3D545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB6153"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "200.6,134.3 265,69.8 232.7,37.5 135.9,134.3  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329.3,228.8v-33.1H343c6,0,9,2.6,9,7.9c0,4.6-3.2,7.8-9.7,9.7l11.2,15.4H350l-11-15.3v-1.6c6.8-1,10.2-3.7,10.2-8 c0-4-2.2-6-6.7-6h-10.8v30.9H329.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.9,204.5c6.6,0,10,3.7,10,11c0,0.5,0,1.1,0,1.6h-18.4c0,6.3,3.4,9.5,10.1,9.5c2.8,0,5.2-0.4,7.4-1.2v2.1 c-2.1,0.8-4.6,1.2-7.4,1.2c-8.3,0-12.5-4.1-12.5-12.4C357,208.5,360.6,204.5,367.9,204.5z M359.4,215h16.1 c-0.1-5.6-2.6-8.5-7.6-8.5C362.5,206.5,359.7,209.4,359.4,215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.2,228.8c0,5.9-3.6,8.8-10.7,8.8c-3,0-5.6-0.4-8-1.2v-2.1c2.4,0.8,5,1.2,8,1.2c5.5,0,8.2-2.2,8.2-6.7v-1.2 c-2.7,0.8-5.2,1.2-7.3,1.2c-7.7,0-11.5-4.1-11.5-12.3c0-8,4.1-12,12.4-12c3.1,0,6.1,0.3,8.8,1V228.8z M401.7,207.2 c-2.2-0.4-4.4-0.6-6.6-0.6c-6.5,0-9.8,3.3-9.8,9.8c0,6.7,3.1,10,9.2,10c2.2,0,4.6-0.4,7.2-1.2V207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.7,195.7v2.8h-2.9v-2.8H414.7z M414.5,204.5v24.3H412v-24.3H414.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2,216.6c0-8.2,3.8-12.4,11.3-12.4c7.6,0,11.3,4.1,11.3,12.4c0,8.2-3.8,12.3-11.3,12.3 C425,229,421.2,224.9,421.2,216.6z M432.5,226.9c5.9,0,8.9-3.5,8.9-10.4c0-6.8-3-10.2-8.9-10.2c-5.9,0-8.9,3.4-8.9,10.2 C423.6,223.5,426.5,226.9,432.5,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,228.8v-24.3h1.7l0.3,3.1c3.1-2.1,6.1-3.1,9.1-3.1c5.9,0,8.9,2.6,8.9,7.7v16.6h-2.4v-16.7c0-3.6-2.2-5.4-6.5-5.4 c-2.9,0-5.8,1-8.6,3.1v19H450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,227.6v-2.3c2.7,0.9,5.3,1.4,8,1.4c5.1,0,7.7-1.6,7.7-4.9c0-2.6-1.9-3.9-5.7-3.9h-3.1c-5.1,0-7.6-2.2-7.6-6.5 c0-4.6,3.4-6.9,10.1-6.9c2.6,0,5.2,0.4,7.9,1.2v2.3c-2.7-0.9-5.3-1.4-7.9-1.4c-5.1,0-7.7,1.6-7.7,4.9c0,2.8,1.7,4.2,5.2,4.2h3.1 c5.4,0,8.1,2.1,8.1,6.2c0,4.6-3.4,6.9-10.1,6.9C482.3,228.8,479.7,228.4,477,227.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 231.2,
    y: 83.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 9.941 206.348)",
    className: "st3",
    width: 45.7,
    height: 14.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8f2b6138.svg";
export { ForwardRef as ReactComponent };